export enum LogOperationsEnum {
    ASSIGNED = 'ASSIGNED',
    DE_ASSIGNED = 'DE_ASSIGNED',
    TRANSFER = 'TRANSFER',
   
}